export enum ElectricMeterPaymentType {
    None = 0,
    Flatrate = 1,
    BasicCharge = 2
}
